/** @param {number|string|null|undefined} value */
export function formatNeoCoins(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) {
    return null;
  }
  return amount.toLocaleString('pt-BR');
}
